import React from 'react'

export const VetInfo = (props) => {
  let isMinMode = !!props.minMode
  if (props.vetInfo.fetching) {
    return (
      <div className='vis-searching'>Searching...</div>
    )
  }
  else if (props.vetInfo.error) {
    return (
      <div className='vis-not-found'>
        <hr />
        Invalid search
      </div>
    )
  }
  else if (props.vetInfo.veteran) {
    return renderSingleVeteran(props.vetInfo, isMinMode)
  }
  else if (props.vetInfo.list) {
    return (
      <div className='vet-list'>
        <h4>Multiple records founds:</h4>
        <ul className='vet-list'>
          {props.vetInfo.list.map(vet =>
            <li key={vet.vaId} value={vet.vaId} onClick={props.getProfile}>
              {vet.firstName}&nbsp;{vet.middleName ? `${vet.middleName} ` : ''}{vet.lastName}&nbsp;{vet.birthDate}
            </li>)}
        </ul>
      </div >
    )
  }

  return null
}

export const renderSingleVeteran = (vetInfo, isMinMode) => {
  let veteran = vetInfo.veteran
  return (
    <div className='vet-info-display'>
      <div className='vet-profile'>
        <h4>Veteran Profile</h4>
        <span className='expand-msg'>Expand VIS to see more</span>
        <hr />
        <div className='usa-width-one-half first-col'>
          <b>Name:</b> {veteran.firstName} {veteran.middleName} {veteran.lastName}<br />
          {(!isMinMode || veteran.alias) && <span><b>Alias:</b> {veteran.alias}<br /></span>}
          <b>DOB:</b> {veteran.birthDate}<br />
          {(!isMinMode || veteran.deathDate) && <span><b>DOD:</b> {veteran.deathDate}<br /></span>}
          <b>Military Status:</b> {veteran.militaryStatus}<br />
          {(!isMinMode || veteran.deathDate) && <span><b>OEF/OIF:</b> {veteran.oefOif === 'T' ? 'Yes' : 'No'}<br /></span>}
        </div>
        <div className='usa-width-one-half second-col'>
          <b>Home of Record:</b> {veteran.homeOfRecord}<br />
          <b>Education:</b> {veteran.education}<br />
          <b>Sex:</b> {veteran.gender}<br />
          <b>Ethnicity:</b> {veteran.ethnicity}<br />
          <b>Race:</b> {veteran.race}<br />
        </div>
      </div>
      <div className='mil-history'>
        <h4>Military History</h4>
        <hr />
        <table>
          <thead>
            <tr>
              <th>Service</th>
              <th>Component</th>
              <th>EOD</th>
              <th>RAD</th>
              <th>Rank</th>
              <th>TAFMS</th>
              <th>Char SRV</th>
              <th>Ret Type</th>
            </tr>
          </thead>
          <tbody>
            {vetInfo.records.map(renderMilitaryRecords)}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export const renderMilitaryRecords = (record) => {
  return (
    <tr key={record.eod}>
      <td data-label="Service:">{record.service}</td>
      <td data-label="Component:">{record.component}</td>
      <td data-label="EOD:">{record.eod}</td>
      <td data-label="RAD:">{record.rad}</td>
      <td data-label="Rank:">{record.rank}</td>
      <td data-label="TAFMS:">{record.tafms}</td>
      <td data-label="Char SRV:">{record.charOfDischarge}</td>
      <td data-label="Ret Type:">{record.reasonForSeparation}</td>
    </tr>
  )
}

export default VetInfo
